module.exports = __webpack_public_path__ + "img/logo_mpp_on_red_bg.6937b60e.png";